import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'backtrace';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GET_ERROR_REPORT = createApiNamespacedConstants('get_error_report');
